(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(any-pointer: fine)');
  let observer;

  const revealSelectors = [
    'main[data-template*="index"] > [id$="__media_with_content_RVymQU"] .media-with-content__content',
    'main[data-template*="index"] > [id$="__media_with_content_RVymQU"] .media-with-content__media',
    'main[data-template*="index"] .ro-categories__header',
    'main[data-template*="index"] .ro-category-card',
    'main[data-template*="index"] .section-resource-list__header',
    'main[data-template*="index"] .ro-promos__header',
    'main[data-template*="index"] .ro-promo-card',
    'main[data-template*="index"] .marquee',
    'main[data-template*="index"] > .shopify-section:not([id$="__media_with_content_RVymQU"]) .media-with-content',
    'main[data-template*="index"] .ro-newsletter',
    'main[data-template*="index"] .ro-benefit-card'
  ];

  function bindReveal(root = document) {
    if (reduceMotion.matches) {
      root.querySelectorAll('.ro-motion-item').forEach((item) => item.classList.add('is-visible'));
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -7% 0px'
      });
    }

    const items = root.querySelectorAll(revealSelectors.join(','));
    items.forEach((item, index) => {
      if (item.dataset.roMotionBound === 'true') return;
      item.dataset.roMotionBound = 'true';
      item.classList.add('ro-motion-item');
      item.style.setProperty('--ro-motion-delay', `${Math.min(index % 5, 4) * 65}ms`);

      if (item.matches('main[data-template*="index"] > [id$="__media_with_content_RVymQU"] .media-with-content__media')) {
        item.classList.add('ro-motion-item--side');
      }

      observer.observe(item);
    });
  }

  function bindHeroParallax(root = document) {
    if (reduceMotion.matches || !finePointer.matches) return;

    root
      .querySelectorAll('main[data-template*="index"] > [id$="__media_with_content_RVymQU"] .media-with-content__media')
      .forEach((media) => {
        if (media.dataset.roParallaxBound === 'true') return;
        media.dataset.roParallaxBound = 'true';

        const frame = media.querySelector('.media-block');
        if (!frame) return;

        let frameId = 0;
        const update = (event) => {
          const rect = media.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 9;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 9;

          cancelAnimationFrame(frameId);
          frameId = requestAnimationFrame(() => {
            frame.style.setProperty('--ro-parallax-x', `${x.toFixed(2)}px`);
            frame.style.setProperty('--ro-parallax-y', `${y.toFixed(2)}px`);
          });
        };

        media.addEventListener('pointermove', update, { passive: true });
        media.addEventListener('pointerleave', () => {
          cancelAnimationFrame(frameId);
          frame.style.setProperty('--ro-parallax-x', '0px');
          frame.style.setProperty('--ro-parallax-y', '0px');
        }, { passive: true });
      });
  }

  function init(root = document) {
    document.documentElement.classList.add('ro-motion-ready');
    bindReveal(root);
    bindHeroParallax(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('.ro-motion-item').forEach((item) => item.classList.add('is-visible'));
  });

  reduceMotion.addEventListener?.('change', () => {
    document.querySelectorAll('.ro-motion-item').forEach((item) => item.classList.add('is-visible'));
  });
})();
